import { useState, useEffect, ReactNode } from 'react';
// 组件
import { ProTooltip } from '../../antd';
// 方法
import { filterEmptyValue } from '../../utils/utils';
// 常量
import { columnsProps } from '../../SuperTable/interface';
import { rowRenderType } from '../mainSubTable';
import { TABLE_COLUMN_EMPTY } from '../../constants/constant';

function useMainColumns(
  columns: columnsProps[],
  groupTotal?: string[],
  rowRender?: rowRenderType,
  onZoom?: (parnetKey: string, status: boolean) => void,
  onZoomText?: (count: number, record: any) => ReactNode,
) {
  const [mianColumns, setMianColumns] = useState<columnsProps[]>([]);
  useEffect(() => {
    setMianColumns(
      [...columns].map((column, index) => {
        return {
          ...column,
          onCell: (record: any) => {
            if (record.isMainTable) {
              return {
                colSpan: index === 0 ? columns.length : 0,
                className: 'yb-table-row-main',
              };
            }
            if (record.isChildrenHidden !== undefined) {
              return {
                colSpan: index === 0 ? columns.length : 0,
                className: 'yb-table-row-more',
              };
            }
            return {};
          },
          render: (val: any, record: any, key: number) => {
            if (record.isMainTable) {
              if (index === 0) {
                return rowRender && rowRender(record)
              }
              return null;
            }
            if (record.isTotal) {
              if (index === 0) {
                return '小计';
              }
              const { dataIndex } = column;
              if (
                groupTotal &&
                typeof dataIndex === 'string' &&
                groupTotal.includes(dataIndex)
              ) {
                const dataIndexVal: any = record[dataIndex];
                return dataIndexVal;
              }
              return TABLE_COLUMN_EMPTY;
            }
            if (record.isChildrenHidden !== undefined) {
              if (index === 0) {
                return (
                  <>
                    {record.isChildrenHidden ? (
                      <div
                        className="main-sub-table-more"
                        onClick={() => onZoom?.(record.parnetKey, false)}
                      >
                        {onZoomText?.(record?.surplusNum, record) ??
                          `查看剩余${record?.surplusNum}个商品`}
                      </div>
                    ) : (
                      <div
                        className="main-sub-table-more"
                        onClick={() => onZoom?.(record.parnetKey, true)}
                      >
                        点击收起
                      </div>
                    )}
                  </>
                )
              }
              return null;
            }
            if (column.render) return column.render(val, record, key);
            if (typeof val === 'string' || typeof val === 'number') {
              return (
                <ProTooltip placement="topLeft" title={val}>
                  {val}
                </ProTooltip>
              );
            }
            return filterEmptyValue(val);
          },
        };
      }),
    );
  }, [columns, rowRender]);
  return mianColumns;
}

export default useMainColumns;
